import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {BacnetDataPoint} from "../../../../domain/device.interface";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'eis-gateway-bacnet-preview-undeployed-datapoint-table',
  templateUrl: './bacnet-preview-undeployed-datapoint-table.component.html',
  styleUrls: ['./bacnet-preview-undeployed-datapoint-table.component.scss']
})
export class BacnetPreviewUndeployedDatapointTableComponent implements  AfterViewInit,OnChanges {
  public displayedColumns: string[] = ['deviceId', 'key', 'dataType', 'value', 'unit', 'description', 'pollingIntervalSeconds']

  @Input()
  datapoints: BacnetDataPoint[];

  @ViewChild(MatSort) sort: MatSort;

  datapointsDataSource:MatTableDataSource<BacnetDataPoint> = new MatTableDataSource<BacnetDataPoint>();

  constructor() {
  }



  ngAfterViewInit(): void {
    this.datapointsDataSource.sort=this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['datapoints']) {
      this.datapointsDataSource.data=this.datapoints
    }
  }

}
